module.exports = __webpack_public_path__ + "static/img/avator_example.ac35b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avator_example.jpg
// module id = OAaD
// module chunks = 1